<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: lixianbing
 * @LastEditTime: 2020-4-16
 -->
<template>
  <div class="home">
    <!-- 顶部模块 -->
    <div class="box">
      <div class="title">请填写附件分享地址</div>
      <div class="inputs">
        <el-input v-model="input" placeholder></el-input>
      </div>
      <div class="text">
        <p>
          注意：报名时请下载艺术信息报名表，完善信息，以附件形式上传。报名后和团队录音、介绍文件、照片、视频等材料一起压缩打包，上传至百度网盘、QQ微云，在以上分享地址栏填写。
          请务必确保已拥有所提交和分享的资料的合法使用版权，本网站平台不对此做任何的担保及不承担因此版权纠纷而导致面临任何第三方的索赔、诉讼或仲裁等要求。
        </p>
        <span>
          <a
            href="https://jingyan.baidu.com/article/d45ad14849906069552b809d.html"
            target="blank"
            >上传百度网盘方法</a
          >
        </span>
        <span>
          <a
            href="https://jingyan.baidu.com/article/46650658d62771f548e5f811.html"
            target="blank"
            >上传QQ微云方法</a
          >
        </span>
      </div>
      <div class="buttonbox">
        <el-button type="primary" @click="uploads">确定</el-button>
        <el-button>取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/plugins/upload/bus";

import { upload_share } from "@/api/file"; // 接口导入

export default {
  components: {},
  computed: {},
  data() {
    return {
      input: "",
    };
  },

  created() {},
  mounted() {
    localStorage.setItem("states", 1);
  },
  methods: {
    uploads() {
      let data = {
        applyId: localStorage.getItem("id"),
        shareUrl: this.input,
      };
      upload_share(data).then((res) => {
        if ((res.code = 200)) {
          this.$message.success("上传成功");
        }
      });
    },
  },
};
</script>

<style scoped="" lang="scss">
.home {
  background: white;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.05);
  border-radius: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .box {
    margin: auto;
    .title {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #3c4353;
      line-height: 34px;
      text-align: center;
    }
    .inputs {
      margin: auto;
      width: 55%;
      margin-top: 36px;
    }
    .text {
      margin: auto;
      width: 55%;
      margin-top: 24px;
      line-height: 34px;
      p {
        color: rgba(252, 82, 76, 1);
        font-size: 16px;
        font-family: MicrosoftYaHei;
      }
      span {
        display: inline-block;
        width: 100%;

        cursor: pointer;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        a {
          color: rgba(22, 122, 252, 1);
        }
      }
    }
    .buttonbox {
      margin: auto;
      margin-top: 30px;
      width: 55%;
      text-align: center;
      .el-button {
        padding: 12px 30px;
        &:last-of-type {
          margin-left: 60px;
        }
      }
    }
  }
}
</style>


